import { render, staticRenderFns } from "./msDialog.vue?vue&type=template&id=ca901966&scoped=true&"
import script from "./msDialog.vue?vue&type=script&lang=js&"
export * from "./msDialog.vue?vue&type=script&lang=js&"
import style0 from "./msDialog.vue?vue&type=style&index=0&id=ca901966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca901966",
  null
  
)

export default component.exports